import { ColorPresetConfig } from './generic-colorpreset.component';
import { DEFAULT_TAG_COLOR_PRESETS } from './defaults';

export const CENTER_COLOR_PRESET_CONFIG: ColorPresetConfig = {
  colorPresets: DEFAULT_TAG_COLOR_PRESETS,
  placeholder: 'Chọn bộ màu có sẵn để thiết lập nhanh',
  onDependencyChange: (dependencyValue: any) => {
    console.log('Color preset changed for center:', dependencyValue);
  }
};

export const SETTING_COLOR_PRESET_CONFIG: ColorPresetConfig = {
  colorPresets: DEFAULT_TAG_COLOR_PRESETS,
  placeholder: 'Chọn bộ màu có sẵn để thiết lập nhanh',
  onDependencyChange: (dependencyValue: any) => {
    console.log('Color preset changed for setting:', dependencyValue);
  }
};

// Default config for general use (without Vietnamese text)
export const DEFAULT_COLOR_PRESET_CONFIG: ColorPresetConfig = {
  colorPresets: DEFAULT_TAG_COLOR_PRESETS,
  placeholder: 'Choose a color preset for quick setup',
  onDependencyChange: (dependencyValue: any) => {
    console.log('Color preset changed:', dependencyValue);
  }
};